import React, { Component, Fragment, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Badge, Button, Col, Row } from 'reactstrap';
import { withRouter } from 'react-router-dom';

import NavigationTree from '../../navigation/NavigationTree';
import Paths from '../../../types/Paths';
import globalTranslations from '../../../i18n/globalTranslations';
import RouteService from '../../../services/RouteService';
import UIStore from '../../../store/UIStore';
import { modelOf } from '../../../prop-types';
import Icon from '../../common/Icon';
import CollapseMenu from '../../common/CollapseMenu';
import TopLevelNavigationDropdown from '../../common/TopLevelNavigationDropdown';
import ConfigStore from '../../../store/ConfigStore';

export const MyAccountNavigation = ({
  uiStore,
  configStore,
  routeService,
  routes,
  orderCount,
  userCount,
}) => {
  const [collapse, setCollapse] = useState(false);

  const convertPathsToNavigationEntities = () => {
    const labels = {
      [Paths.MyAccount]: <FormattedMessage {...globalTranslations.myAccount} />,
      [Paths.MyAccountBalanceUser]: (
        <FormattedMessage {...globalTranslations.myAccount} />
      ),
      [Paths.MyAccountBalanceSubUser]: (
        <FormattedMessage {...globalTranslations.myAccount} />
      ),
      [Paths.MyAccountInfo]: (
        <FormattedMessage {...globalTranslations.myAccountInfo} />
      ),
      [Paths.MyAccountBalanceUserAccountInfo]: (
        <FormattedMessage {...globalTranslations.balanceUserAccountInfo} />
      ),
      [Paths.MyAccountOrderList]: (
        <>
          <FormattedMessage {...globalTranslations.myOrderHistoryTitle} />
          {orderCount ? (
            <Badge
              pill
              key={Paths.MyAccountOrderList + orderCount}
              className="MyAccountNavigation__menu-badge"
            >
              {orderCount}
            </Badge>
          ) : null}
        </>
      ),
      [Paths.MyAccountChangePassword]: (
        <FormattedMessage {...globalTranslations.myAccountChangePassword} />
      ),
      [Paths.MyAccountAddressList]: (
        <FormattedMessage {...globalTranslations.addressBookTitle} />
      ),
      [Paths.MyAccountUserList]: (
        <>
          <FormattedMessage {...globalTranslations.userListTitle} />
          {userCount ? (
            <Badge
              pill
              key={Paths.MyAccountUserList + userCount}
              className="MyAccountNavigation__menu-badge"
            >
              {userCount}
            </Badge>
          ) : null}
        </>
      ),
      [Paths.MyAccountPurchasesList]: (
        <FormattedMessage {...globalTranslations.purchasesListTitle} />
      ),
      [Paths.MyAccountCreditAccount]: (
        <FormattedMessage {...globalTranslations.creditAccountTitle} />
      ),
      [Paths.MyAccountBalanceUserPaymentHistory]: (
        <FormattedMessage
          {...globalTranslations.balanceUserAccountBalanceInfo}
        />
      ),
      [Paths.CustomerProducts]: (
        <FormattedMessage {...globalTranslations.customerProductsTitle} />
      ),
      [Paths.MyAccountPaymentTokenList]: (
        <FormattedMessage {...globalTranslations.paymentTokensTitle} />
      ),
      [Paths.MyAccountRecurringOrderList]: (
        <FormattedMessage {...globalTranslations.recurringOrdersTitle} />
      ),
    };

    return routes
      .filter((route) => !!labels[route.path])
      .map((route) => {
        return {
          id: route.path,
          label: labels[route.path],
          path: routeService.getPath(route.path),
        };
      });
  };

  const toggle = () => {
    setCollapse(!collapse);
  };

  const navigation = (
    <NavigationTree items={convertPathsToNavigationEntities()} />
  );

  if (uiStore.isMobile) {
    return (
      <Row className="MyAccountNavigation">
        <Col
          className="MyAccountNavigation__toggle-col"
          xs="12"
          onClick={toggle}
        >
          <Button>
            <Icon name="bars" className="fa-2x" />
          </Button>
        </Col>
        <Col className="MyAccountNavigation__sidebar" xs="12">
          <CollapseMenu collapse={collapse}>{navigation}</CollapseMenu>
        </Col>
      </Row>
    );
  }
  return (
    <div className="MyAccountNavigation">
      {uiStore.isDesktop && configStore.navigation.sidebar.enabled && (
        <TopLevelNavigationDropdown />
      )}
      <div className="MyAccountNavigation__sidebar">{navigation}</div>
    </div>
  );
};

MyAccountNavigation.propTypes = {
  uiStore: modelOf(UIStore).isRequired,
  configStore: modelOf(ConfigStore).isRequired,
  routeService: PropTypes.instanceOf(RouteService).isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
  orderCount: PropTypes.number,
  userCount: PropTypes.number,
};

export default inject(
  'routeService',
  'uiStore',
  'configStore'
)(observer(withRouter(MyAccountNavigation)));
